import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/breadcrumb--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-breadcrumb--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvbreadcrumb--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=breadcrumb'
    }} knobs={{
      Breadcrumb: ['noTrailingSlash'],
      BreadcrumbItem: ['isCurrentPage']
    }} mdxType="ComponentDemo">{`
<Breadcrumb>
  <BreadcrumbItem href="/">Breadcrumb 1</BreadcrumbItem>
  <BreadcrumbItem href="/">Breadcrumb 2</BreadcrumbItem>
</Breadcrumb>
`}</ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      